export default function serializeFormValues (form) {
  const values = form.serializeArray()

  const inputs = {}

  $.each(values, (k, v) => {
    inputs[v.name] = v.value
  })

  // console.log(inputs)
  return inputs
}
